module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"prediction":"Прогноз","panchanga":"Панчанга","calendar":"Календарь","support":"Поддержка","settings":"Настройки"}}')
  delete Component.options._Ctor
}
